import type { EntityTranslations, LocalizedTextMap } from '../types';
import { getLanguageCandidates } from '../../utils/languageCandidates';

function normalizeLanguageCode(code: string): string {
  return code.trim().toLowerCase();
}


function getTranslationValue(
  translations: EntityTranslations | null | undefined,
  languageCode: string,
  field: 'name' | 'description',
): string | null {
  if (!translations) {
    return null;
  }

  for (const candidate of getLanguageCandidates(languageCode)) {
    const translated = translations[candidate]?.[field];
    if (typeof translated === 'string' && translated.trim()) {
      return translated;
    }
  }

  return null;
}

export function getLocalizedEntityField(
  entity: {
    name?: string | null;
    description?: string | null;
    translations?: EntityTranslations | null;
  },
  field: 'name' | 'description',
  languageCode: string | null | undefined,
): string {
  if (languageCode) {
    const translated = getTranslationValue(entity.translations, languageCode, field);
    if (translated) {
      return translated;
    }
  }

  const fallback = entity[field];
  return typeof fallback === 'string' ? fallback : '';
}

export function getNormalizedLanguageCode(languageCode: string | null | undefined): string {
  if (!languageCode) {
    return 'en';
  }

  return normalizeLanguageCode(languageCode);
}

export function getLocalizedText(
  value: string,
  translations: LocalizedTextMap | null | undefined,
  languageCode: string | null | undefined,
): string {
  if (languageCode && translations) {
    for (const candidate of getLanguageCandidates(languageCode)) {
      const translated = translations[candidate];
      if (typeof translated === 'string' && translated.trim()) {
        return translated;
      }
    }
  }

  return value;
}
